import axios from 'axios'
import { baseURL } from './base'
import { Message, Loading } from 'element-ui'
import router from '../router/index'
import { SUCCESS_CODE } from './code'
import Vue from 'vue'
import store from '../store/index.js'
import i18n from '../i18n/i18n.js';

let pending = []
let rRequestId = Math.random();
class Request {
	constructor() {
		this.baseURL = baseURL
		this.CancelToken = axios.CancelToken
		this.loading = null
		this.url = ''
		//创建基础配置
		this.requestConfig()
		// 创建实例
		this.service = axios.create(this.axiosRequestConfig)
		//拦截器
		this.interceptorsRequest()
		this.interceptorsResponse()
	}
	requestConfig() {
		this.axiosRequestConfig = {
			baseURL: this.baseURL,
			headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
			//允许发送前修改数据
			transformRequest: [
				function(data) {
					return data
				},
			],
			//允许在then前修改response  用了这个config IE中会被转成字符串 无法成功返回responseText
			// transformResponse: [function(data) {
			//     console.log(JSON.parse(data))
			//     return JSON.parse(data);
			// }],
			timeout: 40000,
			withCredentials: true,
			responseType: 'json',
			xsrfCookieName: 'XSRF-TOKEN',
			xsrfHeaderName: 'X-XSRF-TOKEN',
			maxRedirects: 5,
			validateStatus: function(status) {
				return status >= 200 && status < 300 || status === 302;
			},
		}
	}
	interceptorsRequest() {
		this.service.interceptors.request.use(
            (config) => {
            let token;
            if (!config.forceExecute && config.url == this.url) {
                return void 0
            }
            if(process.env.NODE_ENV === 'production') {
                token = Vue.$cookies.get('Authorization') || sessionStorage.getItem('Authorization');
            } else {
                token = Vue.$cookies.get('_a') || sessionStorage.getItem('_a');
            }
            // token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzeXN0ZW1JZCI6Ik9wZW5BcGkiLCJ1c2VyTmFtZSI6IjEwMDQwMzA2IiwiZXhwIjoxNjM5MTQ2OTgwLCJ1c2VySWQiOjE3NDAyOCwiaWF0IjoxNjM5MTI1MzgwfQ.MShVWxnD-fIX9ZnJBmMWnTzOQhdQa_b570ssL_mZ2Ww'
            if(config.params) {
                config.params.requestId = rRequestId
            } else {
                config.params = {
                    requestId : rRequestId
                }
            }
            if(config.isUgly) {
                config.headers['Content-Type'] = 'application/json'
            }
            if(token) {
                config.headers.Authorization = token;
            }
            this.url = config.url;
            if(config.loading) {
                this.loading = Vue.prototype.$loading({
                    lock: true,
                    text: 'Loading...',
                    background: 'rgba(255, 255, 255 , 0.7)',
                    target: config.loadingTarget || 'body'
                })
            }
            return config
        },(error) => {
            this.url = ''
            return Promise.reject(error);
        })
    }
    interceptorsResponse() {
        return this.service.interceptors.response.use((response) => {
            this.removePending(response.config)
            // if (response.data == null && response.config.responseType === 'json' && response.request.responseText != null) {
            //     console.log(response.responseText);
            //     return response.responseText
            // }
            this.url = '';
            rRequestId = Math.random();
            if(!SUCCESS_CODE.includes(response.status)) {
                let msg = response.data.message || response.data.result;
                switch(response.data.code) {
                    case 401:
                        return Promise.reject(new Error(response.message || 'Error'));
                        break;
                    case 503:
                        return Promise.reject(new Error(response.message || 'Error'))
                        break;
                    }
                if(response.data.code == 401 ) {
                    return Promise.reject(new Error(response.message || 'Error'))
                }
            } else {
                this.loading && this.loading.close && this.loading.close();
                return response.data
            }
            return response
        }, (error) => {
            console.dir(error)
            this.loading && this.loading.close();
            this.url = ''
            if(error.message == 'cancel') {
                return {
                    code: 'N',
                    message: '正在查询，请勿频繁操作',
                    response: 'error'
                }
            }
            const response = error && error.response;
            this.loading && this.loading.close();
            if(!response.status) return void 0;
            switch (response.status) {
                case 401:
                case '401':
                    // Message.error(i18n.t('permissionErr'));
                    console.log(error.response)
                    if(['/gm/redirect'].includes(error.response.config.url )) {
                        location.href = location.origin + '/app' + error.response.config.url  + `?webUrl=${error.response.config.params.webUrl}`
                    } else {
                        // location.href = location.origin + '/app' + error.response.config.url  + `?webUrl=${router.currentRoute.path}`
                        location.href = error.response?.headers?.location
                    }
                    // console.log(error.response.headers)
                    // console.log(error.response.headers.location)
                    break;
                case 403:
                case '403':
                    Vue.$cookies.remove('Authorization')
                    Message.error(i18n.t('logErr'))
                    //这里重定向去登陆
                    break;
                case 500:
                case 503:
                case '503':
                case '500':
                    Message.error(i18n.t('versionErr'));
                    break;
                default:
                    Message.error(i18n.t('timeoutErr'));
                    // Message.error("请求无响应或请求超时，请稍后重试");
                    break;
            }
            return error.response
        })
    }
    //cancelToken
    removePending(config) {
        for (let p in pending) {
            let li = pending[p];
            if(li.url === `${config.url}/&request_type=${config.method}`) {
                li.cancel && li.cancel('cancel');
                pending.splice(p, 1)
            }
        }
    }
    async all(config) {
        try {
            const result = await this.service(config);
            return  result;
        } catch (error) {
            console.error(error)
        }
    }
    async get(url,params,config) {
        try {
            const result = await this.service.get(url, params, config);
            return  result;
        } catch (error) {
            console.error(error)
        }
    }
    async post(url,data,config = {}) {
        if(!config.headers) {
            config.headers = {
                'Content-Type': 'application/json'
            }
        }
        try {
            const result = await this.service.post(url,data,config)
            return result
        } catch (error) {
            console.error(error)
        }
    }
    //只暴露出一个方法创建实例
    static startRequest() {
        this._request || (this._request = new Request());
        return this._request;
    }
}

export default Request.startRequest()
